
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"54","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.468 23.667H67.35v6.666H13.39l18.698 18.699-4.714 4.714L.667 27.039 27.373.333l4.714 4.714z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    